// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"Select_selectWrapper__1fjk4","select":"Select_select__2wTma","placeholder":"Select_placeholder__1h6OR"};